// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__+9J-+","closeModalIcon":"PopUpModal_closeModalIcon__OiHqc"};